import { FC } from "react";
import Link from "next/link";
import { TranslationScopes, AssetsDirectory } from "@finbackoffice/enums";
import Translate from "components/base/translate/Translate";
import Img from "components/base/img/Img";
import { Svg } from "components/base/svg/Svg";
import useSkinVersion from "hooks/base/useSkinVersion";
import styles from "./not-found.module.sass";

type IProps = {
    statusCode: number;
};

export const NotFound: FC<IProps> = ({ statusCode }) => {
    const { isXrpBet } = useSkinVersion();

    return (
        <section className={styles.notFoundPage}>
            <div className={styles.notFoundPageContent}>
                <div>
                    <div className={styles.leftBubble}>
                        <span>
                            <strong>{statusCode}</strong>
                            <Translate
                                tid="not_found_page_error"
                                namespace={TranslationScopes.NotFound}
                            />
                        </span>
                        <span>
                            <Translate
                                tid="not_found_page_head"
                                namespace={TranslationScopes.NotFound}
                            />
                        </span>
                        <p>
                            <Translate
                                tid="not_found_page_txt"
                                namespace={TranslationScopes.NotFound}
                            />
                        </p>
                    </div>
                    {isXrpBet ? (
                        <Img
                            source={`/${AssetsDirectory.Mobile}/not-found-basketball.webp`}
                            alt="Not Found"
                            width={270}
                            height={211}
                            prefixAppName
                        />
                    ) : (
                        <Svg
                            src={`/${AssetsDirectory.Mobile}/logo.svg`}
                            className={styles.notFoundLogo}
                            prefixAppName
                        />
                    )}
                    <span className={styles.img} />
                </div>
                {statusCode !== 500 && (
                    <Link href="/" className={styles.goToHome}>
                        <Translate
                            tid="not_found_page_go_home"
                            namespace={TranslationScopes.NotFound}
                        />
                    </Link>
                )}
            </div>
        </section>
    );
};
